/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_A1Inputs */

const en_viewer_faq_a1 = /** @type {(inputs: Viewer_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. PureJSON processes everything 100% client-side using your browser. No data is ever transmitted to any server.`)
};

const ko_viewer_faq_a1 = /** @type {(inputs: Viewer_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아닙니다. PureJSON은 브라우저에서 100% 클라이언트 사이드로 모든 것을 처리합니다. 어떤 데이터도 서버로 전송되지 않습니다.`)
};

const ja_viewer_faq_a1 = /** @type {(inputs: Viewer_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。PureJSONはブラウザで100%クライアントサイドですべてを処理します。データがサーバーに送信されることはありません。`)
};

/**
* | output |
* | --- |
* | "No. PureJSON processes everything 100% client-side using your browser. No data is ever transmitted to any server." |
*
* @param {Viewer_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_a1 = /** @type {((inputs?: Viewer_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_a1(inputs)
	if (locale === "ko") return ko_viewer_faq_a1(inputs)
	return ja_viewer_faq_a1(inputs)
});